var Locale = /*#__PURE__*/function (Locale) {
  Locale["CN"] = "zh-CN";
  Locale["EN"] = "en-US";
  Locale["JP"] = "ja-JP";
  Locale["PT"] = "pt-PT";
  Locale["KO_KR"] = "ko-KR";
  return Locale;
}({});
var baseLocale = {
  locale: ''
};
var getTemporaryLocale = function getTemporaryLocale() {
  return baseLocale.locale.length > 0 ? baseLocale.locale : Locale.EN;
};
var setTemporaryLocale = function setTemporaryLocale(locale) {
  baseLocale.locale = locale;
};
var baseGetLocaleObject = function baseGetLocaleObject(localeObjects) {
  var getLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getTemporaryLocale;
  var localeObjectsIndexArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [Locale.CN, Locale.EN, Locale.JP, Locale.PT, Locale.KO_KR];
  var mapIndex = localeObjectsIndexArray.findIndex(function (value) {
    return value === getLocale();
  });
  var enUSIndex = localeObjectsIndexArray.findIndex(function (value) {
    return value === Locale.EN;
  });
  return localeObjects[mapIndex] || localeObjects[enUSIndex] || localeObjects[0];
};
var baseLocaleMessage = function baseLocaleMessage(localeStore) {
  var langParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getTemporaryLocale();
  var lang = langParam;
  return function (props, context) {
    var _ref, _localeStore$lang$pro;
    if (!localeStore[lang]) {
      if (localeStore[Locale.EN]) {
        lang = Locale.EN;
      } else {
        lang = Object.keys(localeStore)[0];
      }
    }
    // assign context
    var result = (_ref = (_localeStore$lang$pro = localeStore[lang][props.id]) !== null && _localeStore$lang$pro !== void 0 ? _localeStore$lang$pro : props.defaultMessage) !== null && _ref !== void 0 ? _ref : props.id;
    if (context && Object.keys(context).length >= 0) {
      Object.keys(context).forEach(function (i) {
        result = result.replace("{".concat(i, "}"), context[i]);
      });
      return result;
    }
    return result;
  };
};
export { Locale, baseGetLocaleObject, baseLocaleMessage, getTemporaryLocale, setTemporaryLocale };
